export default "__VITE_ASSET__DcNDE7OI__"